import { makeContextModule } from '@cian/react-utils';

import { type TSearchOffersDesktopResponse_1 } from '@/repositories/generated/shared/search-offers/v3/search-offers-desktop';

export const {
  Context: { Provider: ListingContextProvider, Consumer: ListingContextConsumer },
  useContext: useListingContext,
  withContext: withListingContext,
} = makeContextModule<TSearchOffersDesktopResponse_1>({
  contextName: 'ListingContext',
});
